import { createSelector } from '@reduxjs/toolkit';
import { State } from '../../../store/state';

export const companyIdSelector = (state: State) => state.company.companyId;
export const companySelector = (state: State) => state.company.company;
export const optionsSelector = (state: State) => state.company.options;
export const totalSelector = (state: State) => state.company.total;
export const noMoreSelector = (state: State) => state.company.noMore;
export const pageSelector = (state: State) => state.company.page;
export const errorCodeSelector = (state: State) => state.company.errorCode;

const companiesIdsSelector = (state: State) => state.company.companies.ids;
const companiesEntitiesSelector = (state: State) => state.company.companies.entities;

export const companiesSelector = createSelector(
  [companiesIdsSelector, companiesEntitiesSelector],
  (ids, entities) => ids.map((id) => entities[id])
);